import { Component, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-oecd-tax-risk-indicators',
  templateUrl: './oecd-tax-risk-indicators.component.html',
  styleUrls: ['./oecd-tax-risk-indicators.component.scss']
})
export class OECDTaxRiskIndicatorsComponent implements OnInit {
  currentSelectedIndex: number = -1;

  data = [
    {
      title: "Accordion Item 1",
      content: null
    },
    {
      title: "Accordion Item 2",
      content: "Content for Accordion Item 2"
    },
    {
      title: "Accordion Item 3",
      content: "Content for Accordion Item 3"
    },
    {
      title: "Accordion Item 4",
      content: null
    },
    {
      title: "Accordion Item 5",
      content: "Content for Accordion Item 5"
    },
    {
      title: "Accordion Item 1",
      content: null
    },
    {
      title: "Accordion Item 2",
      content: null
    },
    {
      title: "Accordion Item 3",
      content: "Content for Accordion Item 3"
    },
    {
      title: "Accordion Item 4",
      content: "Content for Accordion Item 4"
    },
    {
      title: "Accordion Item 5",
      content: "Content for Accordion Item 5"
    },
    {
      title: "Accordion Item 1",
      content: null
    },
    {
      title: "Accordion Item 2",
      content: null
    },
    {
      title: "Accordion Item 3",
      content: null
    },
    {
      title: "Accordion Item 4",
      content: "Content for Accordion Item 4"
    },
    {
      title: "Accordion Item 5",
      content: "Content for Accordion Item 5"
    },
    {
      title: "Accordion Item 1",
      content: null
    },
    {
      title: "Accordion Item 2",
      content: "Content for Accordion Item 2"
    },
    {
      title: "Accordion Item 3",
      content: "Content for Accordion Item 3"
    },
    {
      title: "Accordion Item 4",
      content: "Content for Accordion Item 4"
    },
    {
      title: "Accordion Item 5",
      content: "Content for Accordion Item 5"
    },
  ];


  constructor() { }

  ngOnInit(): void {
  }
  onSelect(index: number): void {
    if (this.currentSelectedIndex === index) {
      this.currentSelectedIndex = -1;
    } else {
      this.currentSelectedIndex = index;
    }
  }
}
